import { formatToDate } from '../../../../util'
import { AuditTable } from './AuditTable'

export const NotStartedTable = ({ assignments, onSelectionChange, selected }) => {
  const assignmentsByDeadlineDate = assignments.sort(sortByDeadlineDate)

  const hasDeadlines = assignments.some((assignment) => !!assignment.deadlineDate)
  const defaultSort = hasDeadlines ? { name: 'deadlineDate', dir: -1 } : { name: 'createdAt', dir: 1 }

  return (
    <>
      <AuditTable
        defaultSortInfo={defaultSort}
        storageKey='not-started'
        data={assignmentsByDeadlineDate}
        onSelectionChange={onSelectionChange}
        selected={selected}
        columns={columns}
        emptyText={'No new audits'}
      />
    </>
  )
}

/**
 * @typedef {{
 *  internalId: string
 * }} ColumnLabels
 */

/**
 * @typedef {{
 *   labels: ColumnLabels
 * }} CreateColsParams
 */

/**
 * @param {CreateColsParams} props
 */
const columns = [
  { dataKey: 'id', defaultVisible: false },
  { label: 'Internal ID', dataKey: 'pepId', defaultWidth: 150 },
  { label: 'Key Stage', dataKey: 'keyStage', width: 150 },
  { label: 'Primary Need', dataKey: 'primaryNeed', width: 150 },
  { label: 'Setting Name', dataKey: 'settingName', defaultFlex: 4 },
  { label: 'Setting Type', dataKey: 'settingType', defaultFlex: 4 },
  {
    label: 'Assigned Date',
    dataKey: 'createdAt',
    width: 120,
    render: ({ value }) => formatToDate(value)
  },
  {
    label: 'Deadline',
    dataKey: 'deadlineDate',
    defaultFlex: 3,
    render: ({ value }) => formatToDate(value)
  }
]

const sortByDeadlineDate = (a, z) => {
  const aDeadlineDate = a?.deadlineDate
  const zDeadlineDate = z?.deadlineDate
  const aIsDefined = !!aDeadlineDate
  const zIsDefined = !!zDeadlineDate
  if (!aIsDefined && !zIsDefined) return 0

  if (!aIsDefined) return 1
  if (!zIsDefined) return -1
  if (aDeadlineDate < zDeadlineDate) return -1
  if (aDeadlineDate > zDeadlineDate) return 1
  return 0
}
